var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pickings && _vm.formater)?_c('div',[_c('v-sheet',{staticClass:"hidden-print",staticStyle:{"margin-top":"80px"}}),_c('MutiplePiecesPrint',{attrs:{"showSinglePrint":true,"formater":_vm.formater,"datas":_vm.pickings}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }